import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  enumActions,
  enumRules,
  HeaderFilters,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { Item } from 'app/models2/inventory/item';
import { Params, Router } from '@angular/router';
import { Warehouse } from 'app/models2/inventory/warehouse';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { UpdateData } from 'app/models2/commos/update-data';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
})
export class InventoryComponent implements OnInit {
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Almacén Inventario',
      current: true,
    },
  ];

  public urlTableI: string = `${EndpointDictionary.Inventory.INVENTORY_TABLE}`;
  public urlComboI: string = `${EndpointDictionary.Item.ITEM_COMBO}`;
  private urlWarehouseCombo: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public params: Params = [{ id: 'warehouseId', value: null }];
  public warehouses: Warehouse[];
  private itemData: Item[] = [];

  public reloadTablaI = new Array<EventEmitter<any>>();
  public configurationI: TableConfiguration = {
    edit: true,
    primaryKey: 'itemId',
    exportXslx: true,
    hideTitle: true,
    notInitialize: true,
  };

  public columnasI: TableColumns<Item>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      disregardForEdit: true,
    },
    {
      ID: 'itemName',
      label: 'Item',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      disregardForEdit: true,
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
      disregardForEdit: true,
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      disregardForEdit: true,
    },
    {
      ID: 'costItem',
      label: 'Costo Unitario',
      type: 'number',
      style: {
        textAlign: 'center',
      },
      disregardForEdit: true,
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Items',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      disregardForEdit: true,
    },
    {
      ID: 'minStock',
      label: 'Stock Mínimo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'maxStock',
      label: 'Stock Máximo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      rules: [
        {
          rule: enumRules['=='],
          valueRule: '-1',
          action: enumActions.REPLACE,
          valueAction: '',
        },
      ],
    },
  ];

  headerFilters: Array<HeaderFilters> = [];

  headerFileXlsm: Array<params> = [
    { id: 'code', value: 'Código Item' },
    { id: 'itemName', value: 'Nombre Item' },
    { id: 'amount', value: 'Cantidad' },
    { id: 'unitMeasurement', value: 'Unidad' },
    { id: 'costItem', value: 'Costo Unidad' },
    { id: 'totalCostItems', value: 'Costo Total' },
    { id: 'minStock', value: 'Stock Mínimo' },
    {
      id: 'maxStock',
      value: 'Stock Máximo',
      rules: [
        {
          rule: enumRules['=='],
          valueRule: '-1',
          action: enumActions.REPLACE,
          valueAction: '0',
        },
      ],
    },
  ];

  constructor(
    private storage: LocalStorageService,
    private http: HttpService,
    private message: MessageService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.warehouses = await this.http.getDataBody(`${this.urlWarehouseCombo}`, [
      { id: 'active', value: 1 }
    ]);
    if (this.warehouses.length === 0) {
      this.message
        .Warning('No hay bodegas registradas', '¿Desea Registrar bodega?', true)
        .then((res) => {
          if (res) this.router.navigate(['/almacen/bodegas']);
        });
      return;
    }
    for (const warehouse of this.warehouses) {
      this.reloadTablaI.push(new EventEmitter<any>());
    }
    this.itemData = await this.http.getDataBody(this.urlComboI);
    this.headerFilters = [
      {
        tN: 'item_inventario',
        labelFilter: 'Código',
        visibleField: 'code',
        primaryKey: 'id',
        type: 'select',
        value: '',
        data: this.itemData,
      },
      {
        tN: 'item_inventario',
        labelFilter: 'Item',
        visibleField: 'itemName',
        primaryKey: 'id',
        type: 'select',
        value: '',
        data: this.itemData,
      },
    ];
  }

  updateParams(event: MatTabChangeEvent): void {
    const warehouseId = this.warehouses[event.index].id;
    this.params[0].value = warehouseId;
    this.reloadTablaI[event.index].emit();
  }

  async editStock($event: UpdateData<Item>, index: number) {
    let form: Item = {
      minStock: $event.new.minStock as number,
      maxStock: $event.new.maxStock ? ($event.new.maxStock as number) : -1,
      warehouseId: this.params[0].value,
      itemId: $event.old.itemId,
    };
    await this.handlerData(
      EndpointDictionary.Inventory.PUT_STOCK_IVENTORY,
      form,
      index
    );
  }

  async handlerData(url: string, body: Item, index: number) {
    this.message.openLoading('Cargando', 'Actualizando');
    let res = await this.http.putDataBody<GenericResponse>(url, body);
    if (res) {
      this.message.SuccessToast(res.message);
    }
    this.reloadTablaI[index].emit();
    this.message.closeLoading();
  }
}
